import { render, staticRenderFns } from "./RiskSnapshot.vue?vue&type=template&id=088c71ad&scoped=true"
import script from "./RiskSnapshot.vue?vue&type=script&lang=js"
export * from "./RiskSnapshot.vue?vue&type=script&lang=js"
import style0 from "./RiskSnapshot.vue?vue&type=style&index=0&id=088c71ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088c71ad",
  null
  
)

export default component.exports